import { Component, Input, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { CommonModule } from '@angular/common';

export type GridBreakpoint = {
  minWidth?: number;
  maxWidth?: number;
  columns: number;
  gap?: string;
  autoFit?: boolean;
};

export type GridPreset =
  | 'auto'
  | '4cols'
  | '3cols'
  | '2cols'
  | '1col'
  | 'responsive'
  | '3cols-responsive';

@Component({
  selector: 'app-grid-form',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="grid-form-container" [ngClass]="wrapperClass">
      <div
        class="grid-form"
        [style.display]="'grid'"
        [style.gap]="currentGap"
        [style.gridTemplateColumns]="gridTemplateColumns"
      >
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      .grid-form-container {
        width: 100%;
      }

      .grid-form {
        display: grid;
        width: 100%;
        transition: all 0.3s ease;
      }

      :host ::ng-deep .grid-item {
        min-width: 0;
        width: 100%;
      }
    `,
  ],
})
export class GridFormComponent implements OnInit, OnDestroy, AfterContentInit {
  @Input() preset: GridPreset = 'responsive';
  @Input() columns = 4;
  @Input() gap = '1.5rem';
  @Input() wrapperClass = '';

  gridTemplateColumns = '';
  currentGap = '1.5rem';

  ngOnInit() {
    this.initializeConfig();
    this.updateGridColumns();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  ngAfterContentInit() {
    this.updateGridColumns();
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onResize.bind(this));
  }

  private initializeConfig() {
    switch (this.preset) {
      case '3cols-responsive':
        this.columns = 3;
        break;
      case '4cols':
        this.columns = 4;
        break;
      case '3cols':
        this.columns = 3;
        break;
      case '2cols':
        this.columns = 2;
        break;
      case '1col':
        this.columns = 1;
        break;
      case 'responsive':
        this.columns = 4;
        break;
      case 'auto':
        this.columns = 4;
        break;
    }
  }

  private onResize() {
    this.updateGridColumns();
  }

  private updateGridColumns() {
    const width = window.innerWidth;
    let columns = this.columns;
    let newGap = this.gap;

    if (this.preset === '3cols-responsive') {
      if (width >= 1280) {
        columns = 3;
        newGap = '1.5rem';
      } else if (width >= 768) {
        columns = 2;
        newGap = '1rem';
      } else {
        columns = 1;
        newGap = '0.75rem';
      }
    } else if (this.preset === 'responsive') {
      if (width >= 1280) {
        columns = 4;
        newGap = '1.5rem';
      } else if (width >= 1024) {
        columns = 3;
        newGap = '1.25rem';
      } else if (width >= 768) {
        columns = 2;
        newGap = '1rem';
      } else {
        columns = 1;
        newGap = '0.75rem';
      }
    }

    this.gridTemplateColumns = `repeat(${columns}, minmax(0, 1fr))`;
    this.currentGap = newGap;
  }
}
